import {IDataset, IModelParams} from "./index";
import {PartialRecord, TSyncfield} from "../../../index";
import {ErrorManager} from "../../../error/ErrorManager";
import {nsUserWizard} from "./nsUserWizard";
import {_} from 'lodash';
import {getRawSyncFieldValue} from "../../../util/misc";
import {lm_} from "../../../appContext";
import {ObjectTypeId} from "../../../constants/ObjectTypeId";
import TWizardSyncfield = nsUserWizard.TWizardSyncfield;

export abstract class AbstractModel {
    public readonly Attributes!: Partial<TWizardSyncfield>[]
    public readonly attr!: PartialRecord<TWizardSyncfield, KnockoutObservable<any>>
    public readonly derived: PartialRecord<TWizardSyncfield, KnockoutReadonlyComputed<string | null>> = {}
    public readonly errorManager!: ErrorManager
    public readonly meta!: { [key: string]: KnockoutObservable<any> }
    public readonly dataset: IDataset

    constructor(params: IModelParams) {
        this.dataset = params.dataset
    }

    public initMeta(obj: PartialRecord<any, any>) {
        _.forEach(this.meta, (_obs: KnockoutObservable<any>, k: string) => {
            if (k in obj) {
                this.meta[k]?.(obj[k])
            }
        })
    }

    public initAttr(obj: PartialRecord<TWizardSyncfield, any>) {
        _.forEach(this.attr, (_o: KnockoutObservable<any>, k: TWizardSyncfield) => {
            if (k in obj) {
                this.attr[k]?.(obj[k])
            }
        })
    }

    protected getOriginalValue(name: TSyncfield): string {
        return this.dataset.original
            ? getRawSyncFieldValue(name, this.dataset.original.syncfields) ?? ''
            : ''
    }

    public abstract initErrorObjects(): void

    protected srcTrans(key: TSyncfield) {
        return lm_.getInstance(ObjectTypeId.User).t(key)
    }
}